export enum InsightsState {
  Default = "default",
  Editing = "editing",
  Reordering = "reordering",
}
